export default "__VITE_ASSET__ZA3Xecr7__"